module.exports = __webpack_public_path__ + "img/POWERED BY DILO DELIVERY.c8c18a8d.svg";